import {
    InfoBarMessageSource,
    InfoBarMessageRank,
    InfoBarCustomAction,
    InfoBarOptionsAction,
    InfoBarShowDetailsAction,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function createInfoBarMessageViewState(
    messageId: string,
    messages: (string | InfoBarCustomAction | InfoBarShowDetailsAction | InfoBarOptionsAction)[],
    rank: InfoBarMessageRank = InfoBarMessageRank.Info
): InfoBarMessageViewState {
    return {
        key: messageId,
        source: InfoBarMessageSource.ReadingPane,
        rank: rank,
        message: messages.filter(m => typeof m === 'string').join(' '),
        messageParts: messages,
    };
}
